import { OptionHeader, OptionSearch, OptionSeparator, SelectionOption } from '@starryui10/lists/SelectionOption';
import { OptionLabel } from '@starryui10/lists/SelectionOption/OptionLabel';
import { OptionParagraph } from '@starryui10/lists/SelectionOption/OptionParagraph';
import { OptionSecondaryHeader } from '@starryui10/lists/SelectionOption/OptionSecondaryHeader';
import React, { useState } from 'react';
import { strings } from '../../localization';
import { useLocalStorage } from '../../utils/useLocalStorage';

interface ISearchColumnFilterProps {
    displayName: string;
    field: string;
}

interface IRecentSearches {
    [field: string]: string[];
}

const RecentSearchesStorageName = `mainDirectory_ColumnFilter_RecentSearches`;
export const SearchColumnFilter = ({ displayName, field }: ISearchColumnFilterProps) => {
    const { getStoredObject, storeObject } = useLocalStorage();
    const [recentSearches, setRecentSearches] = useState(getStoredObject<IRecentSearches>(RecentSearchesStorageName)[field] || []);

    const updateStoredRecentSearch = (value: string) => {
        const stored = getStoredObject<IRecentSearches>(RecentSearchesStorageName);
        if (value !== '') {
            if (stored) {
                const tobeStored = stored[field] ? Array.from(new Set([value, ...stored[field]])).slice(0, 5) : [value];
                storeObject<IRecentSearches>(RecentSearchesStorageName, { ...stored, [field]: tobeStored });
                setRecentSearches(tobeStored);
            } else {
                const tobeStored = [value];
                storeObject<IRecentSearches>(RecentSearchesStorageName, { [field]: tobeStored });
                setRecentSearches(tobeStored);
            }
        }
    };
    const handleSearchChange = (value: string) => {
        updateStoredRecentSearch(value);

        //handle column filter refetch here
        return Promise.resolve();
    };

    return (
        <SelectionOption focusFirstElement selector="li > button, input[type='search']">
            <OptionHeader caption={`${strings.ColumnFilter_Label_Search} ${displayName}`} />
            <OptionSeparator />
            <OptionSearch onSearchChange={handleSearchChange} />
            <OptionSecondaryHeader caption={strings.SearchColumnFilter_Label_RecentSearches} />
            {recentSearches && recentSearches.length > 0 ? (
                recentSearches.map((item: string) => <OptionLabel caption={item} />)
            ) : (
                <OptionParagraph caption={strings.SearchColumnFilter_Label_NoRecentSearches} />
            )}
        </SelectionOption>
    );
};
